"use client";

import { usePathDtpgid } from '@ssv-website/hooks';
export const TrackingPage = ({ keyPath }: { keyPath?: string }) => {
    const pgid = usePathDtpgid(keyPath);
    return <div {...pgid}/>
}
